<svg-icon [src]="'assets/icons/'+ (!this.data.isvisible ? 'no-' : '') +'visible.svg'"
  matTooltip="Masquer ou afficher"></svg-icon>
